export const ZONE_OPTIONS = [
    { value: "1", label: "Europa" },
    { value: "2", label: "México" },
    { value: "3", label: "Países no GOA" },
];

export const ZONE_LABEL_MAP = [
    undefined,
    "Europa",
    "México",
    "Países no GOA",
];

export const ZONE_LABEL_MAP_ZERO = [
    "Europa",
    "México",
    "Países no GOA",
];
